import { useEffect, useRef, useState } from "react";
import styles from "./CustomTextArea.module.css";

type Props = {
  value?: string;
  placeholder?: string;
  disable?: boolean;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void; // Исправлено: добавляем event
};

export const CustomTextArea = ({
  value = "",
  placeholder,
  disable = false,
  onChange,
}: Props) => {
  const textareaRef = useRef<HTMLTextAreaElement>(null);
  const trackRef = useRef<HTMLDivElement>(null);
  const thumbRef = useRef<HTMLDivElement>(null);

  const [localValue, setLocalValue] = useState<string>(value);
  const [thumbHeight, setThumbHeight] = useState(20);
  const [showScrollbar, setShowScrollbar] = useState(false);

  const syncThumb = () => {
    const textarea = textareaRef.current;
    const track = trackRef.current;
    const thumb = thumbRef.current;

    if (!textarea || !track || !thumb) return;

    const { scrollTop, scrollHeight, clientHeight } = textarea;

    const needsScroll = scrollHeight > clientHeight;
    setShowScrollbar(needsScroll);

    if (!needsScroll) return;

    const trackHeight = track.clientHeight;
    const height = Math.max((clientHeight / scrollHeight) * trackHeight, 20);
    setThumbHeight(height);

    const maxScroll = scrollHeight - clientHeight;
    const maxThumbTop = trackHeight - height;
    thumb.style.top = `${(scrollTop / maxScroll) * maxThumbTop}px`;
  };

  useEffect(() => {
    syncThumb();
  }, [value]);

  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const newValue = e.target.value;
    setLocalValue(newValue);
    onChange(e);
  };

  return (
    <div className={styles.wrapper}>
      <textarea
        ref={textareaRef}
        disabled={disable}
        className={styles.textarea}
        onScroll={syncThumb}
        value={localValue}
        onChange={handleChange}
        onInput={syncThumb}
        placeholder={placeholder}
      />

      <div
        ref={trackRef}
        className={`${styles.scrollbar} ${!showScrollbar ? styles.hidden : ""}`}
      >
        <div
          ref={thumbRef}
          className={styles.thumb}
          style={{ height: thumbHeight }}
        />
      </div>
    </div>
  );
};
